<template>

    <!-- User history section -->
    <section class="ec-page-content ec-vendor-uploads ec-user-account section-space-p">
        <div class="container">
            <div class="row">
                <!-- Sidebar Area Start -->
                <div class="ec-shop-rightside col-md-12">
                    <div class="ec-vendor-dashboard-card">
                        <div class="ec-vendor-card-header">
                            <h5> {{ $t('Your Orders') }} </h5>
                            <div class="ec-header-btn">
                                <a class="btn btn-lg btn-primary" href="/">{{ $t('Shop now') }}</a>
                            </div>
                        </div>
                        <div class="ec-vendor-card-body">
                            <div class="ec-vendor-card-table">
                                <table class="table ec-table">
                                    <thead>
                                        <tr>
                                            <th scope="col"> #</th>
                                            <th scope="col"> {{ $t('Products') }}</th>
                                            <th scope="col">{{ $t('Date') }} </th>
                                            <th scope="col">{{ $t('Total price') }}</th>
                                            <th scope="col">{{ $t('Payment status') }}</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="order in items?.data" :key="order.id">
                                            <td>

                                                <router-link
                                                    :to="{name: 'orders.show', params: { id: order?.id , lang : $i18n.locale }}" >

                                                    <span class="mb-1">
                                                        {{ $t('Order number') }} <span>{{ order?.id }}</span>
                                                    </span>

                                                </router-link>


                                            </td>
                                            <td>
                                                <div  v-for="item in order?.items" :key="item.id" class="mb-1">
                                                    <template  v-if="item?.product !== null" >


                                                        <router-link :to="{name: 'products.show', params: { id: item?.product?.id , lang : $i18n.locale  }}">

                                                        <div class="d-flex ">
                                                            <div>
                                                                <img class="prod-img me-2" :src="item?.product?.image   ?? '/images/spices-jar.jpeg'"
                                                                     alt="product image"  :alt="item?.product?.name">
                                                            </div>
                                                            <div>
                                                                <div>{{ item?.product?.name }}</div>
                                                                <div>
<!--                                                                        {{ $t('Price')}}: -->
                                                                        {{ item?.price }} {{ $t('SAR')}}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        </router-link>

<!--                                                        <div class="order-wrap">-->

<!--                                                            <ul class="product-size">-->
<!--                                                                <li>-->
<!--                                                                    <div class="size-box">-->
<!--                                                                        <h6 class="text-content">{{ $t('Quantity') }} : </h6>-->
<!--                                                                        <h5>{{ item?.quantity }}</h5>-->
<!--                                                                    </div>-->
<!--                                                                </li>-->
<!--                                                            </ul>-->
<!--                                                        </div>-->
                                                    </template>
                                                    <div class="alert alert-info" v-else>
                                                        منتج محذوف.
                                                    </div>
                                                </div>

                                            </td>
                                            <td><span> {{ order?.created_at }} </span></td>
                                            <td><span>{{ order?.total_price }} {{ $t('SAR') }} </span></td>
                                            <td>
                                                <span :class="{ 'text-success' : order.payment_status == 'paid'  ,}">
                                                    {{ order?.payment_status_value }}
                                                </span>

                                                <a v-if="order?.can_pay === true"
                                                   class="btn btn-lg btn-primary"
                                                   :href="'/payment?id=' + order?.id ">
                                                    {{ $t('Pay now') }} <i class="fa-solid fa-arrow-left icon"></i>
                                                </a>
                                            </td>

                                            <td>
                                                <span class="tbl-btn">

                                                <router-link
                                                    :to="{name: 'orders.show', params: { id: order?.id , lang : $i18n.locale }}" class="btn btn-lg btn-primary" >
                                                    {{ $t('View') }}
                                                </router-link>

                                                </span>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End User history section -->
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

export default {
    components:{
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults ( page = this.$route?.query?.page ?? 1 ) {

            const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });

            axios.get('orders', { params : { 'page' : page, }} ).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
    }
}
</script>
